<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="isEditMode ? 'Edit Offering' : 'Add Offering'"
      [canGoBack]="true"
      [noBow]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">
      @if (loaded) {
        <tidy-card>
          <tidy-row class="field-bottom-padding">
            <tidy-select
              [icon]="'assets/svg/home-outline.svg'"
              [label]="'Property'"
              formControlName="property_id"
              [form]="form.controls.property_id"
              [items]="propertyItems"
              [submitted]="submitted"
              [errorMessage]="'Please select a property.'" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-input
              formControlName="name"
              [form]="form.controls.name"
              [label]="'Offering Name'"
              [icon]="'assets/svg/information-circle.svg'"
              [errorMessage]="'Please enter an offering name.'"
              [submitted]="submitted" />
          </tidy-row>
        </tidy-card>

        <tidy-card>
          <tidy-row [alignLastItemRight]="true">
            <tidy-text [body]="'Allow Upsell'" />
            <tidy-toggle
              [toggled]="form.controls.can_upsell.value"
              (toggleChanged)="form.controls.can_upsell.setValue($event)" />
          </tidy-row>
          <tidy-row [alignLastItemRight]="true">
            <tidy-text [body]="'Allow Comp'" />
            <tidy-toggle
              [toggled]="form.controls.can_comp.value"
              (toggleChanged)="form.controls.can_comp.setValue($event)" />
          </tidy-row>
        </tidy-card>

        <tidy-error-message
          [text]="errorMessage" />

        <tidy-button
          [text]="isEditMode ? 'Save Changes' : 'Add Offering'"
          [action]="boundSave"
          class="primary" />

        @if (isEditMode) {
          <tidy-button
            [text]="'Delete Offering'"
            [action]="boundDelete"
            class="secondary red" />
        }
      }
    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
